// @flow

import React from 'react';
import PackageSlider from './packageSlider';
import PackageCompare from '../../../packageCompare';

const ConfigPackages = () => ([
  <PackageSlider key="package-slider" />,
  <PackageCompare key="package-compare" />,
]);

export default ConfigPackages;
